import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-report-file-type-dialog",
	templateUrl: "./report-file-type-dialog.component.html",
	styleUrls: ["./report-file-type-dialog.component.css"],
})
export class ReportFileTypeDialogComponent implements OnInit {
	constructor(private ref: DynamicDialogRef) {}

	ngOnInit(): void {}

	////////////////////////////////////
	// Data
	////////////////////////////////////
	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];
	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onClose() {
		this.ref.close(0);
	}
	onContinue() {
		this.ref.close(this.OutputTypeID);
	}
}
